import React from 'react';
import PropTypes from 'prop-types';
import './SlideoutFooter.scss';
import classnames from 'classnames';

const propTypes = {
  footerClassName: PropTypes.string,
  isSticky: PropTypes.bool,
  isBoxShadowTheme: PropTypes.bool
};

const defaultProps = {
  hideCloseButton: false,
  isBoxShadowTheme: false
};

const SlideoutFooter = props => {
  //  TODO: This still needs to be updated to provide sticky support
  const footerClassName = classnames({
    ['slideout-footer']: true,
    ['slideout-footer--shadow']: props.isBoxShadowTheme,
    [props.footerClassName]: props.footerClassName
  });
  return <div className={footerClassName}>{props.children}</div>;
};

SlideoutFooter.propTypes = propTypes;
SlideoutFooter.defaultProps = defaultProps;
export default SlideoutFooter;
